module.exports = __webpack_public_path__ + "static/media/preloader-Big-PennyMac-withText-Flood.aff96568.gif";